export const OBTER_OCORRENCIA = 'JUSTIFICATIVA/OBTER_OCORRENCIA'

export const OBTER_GRUPO_USUARIO = 'JUSTIFICATIVA/OBTER_GRUPO_USUARIO'

export const OBTER_DESCRICAO = 'JUSTIFICATIVA/OBTER_DESCRICAO'

export const OBTER_DESCRICAO_DETALHES = 'JUSTIFICATIVA/OBTER_DESCRICAO_DETALHES'

export const INCLUIR_JUSTIFICATIVA = 'JUSTIFICATIVA/INCLUIR_JUSTIFICATIVA'

export const EDITAR_JUSTIFICATIVA = 'JUSTIFICATIVA EDITAR_JUSTIFICATIVA'
